
import { useStore } from "vuex";
import { computed, defineComponent } from "vue";
import { USER_GETTERS } from "@/store/user";
import { ROUTES } from "@/router/constants";
import ENV from "@/constants/env";
import SidebarAccount from "@/components/base/SidebarAccount.vue";
import SidebarCommon from "@/components/base/SidebarCommon.vue";

export default defineComponent({
  name: "SidebarMobile",
  components: { SidebarCommon, SidebarAccount },
  setup() {
    const store = useStore();

    return {
      ROUTES,
      address: computed(() => store.getters[USER_GETTERS.ADDRESS_ELROND]),
    };
  },
  created() {
    this.ENV = ENV;
  },
});
